﻿export class BurgerMenuEventHandler {
    public static handleClickEvents($: JQueryStatic): void {
        $('.burger-menu__container').on('click', function () {
            $(this).toggleClass('burger-open');
        });
    }
};
